const methods = {
    // Consultamos al back las cuentas y productos con descuadres
    async fetchData() {
        this.loading = true;
        try {
            const resAccounts = await this.$accountsService.accountsMismatch();
            const resSummary = await this.$accountsService.accountsMismatchSummary();
            const resMismatchesResume = await this.$accountsService.accountsMismatchesStatus();
            const { accounts_positions_comparisons, products_positions_comparisons } = resAccounts.data;
            const { mismatches_summaries } = resSummary.data;
            this.productsMissmatch = products_positions_comparisons || [];
            this.accountsMissmatch = accounts_positions_comparisons || [];
            this.dailySummary = mismatches_summaries;
            this.fieldsResume = [
                { name: 'Cuentas', value: resMismatchesResume.data.numberOfAccounts },
                { name: 'Descuadres', value: resMismatchesResume.data.numberOfAccountsMismatches },
                { name: 'Cuadre', value: `${resMismatchesResume.data.matchesPercentage.toFixed(2)} %` }
            ];
            this.loading = false;

        } catch (error) {
            console.error(error);
        }
    },

    // Obtenemos el total de cuentas que tienen descuadres en el resumen diario
    getFailedCountResume() {
        if (this.loading) {
            return 0;
        } else {
            let total = 0;
            this.dailySummary.forEach(el => {
                total += el.total_mismatched ? 1 : 0;
            });
            return total;
        }
    },

    // Obtenemos el total de cuentas que tienen descuadres
    getMissmatchCountAccounts() {
        if (this.loading) {
            return 0;
        } else {
            let total = 0;
            this.accountsMissmatch.forEach(el => {
                total += el.has_mismatch ? 1 : 0;
            });
            return total;
        }
    },

    // Obtenemos el total de fondos que tienen descuadres
    getMissmatchCountFunds() {
        if (this.loading) {
            return 0;
        } else {
            let total = 0;
            this.productsMissmatch.forEach(el => {
                total += el.has_mismatch ? 1 : 0;
            });
            return total;
        }
    },

    // Comprobamos si el tab está activo o no
    tabActive(tab) {
        return tab.active ? true : false;
    },
    // Cerramos una pestaña
    closeTab(tab) {
        const index = this.tabsAccount.indexOf(tab);
        if (index === 0) {
            const type = tab.type;
            switch (type) {
                case 'date':
                    this.setActiveTab(0);
                    break;
                case 'keyProduct':
                    this.setActiveTab(1);
                    break;
                case 'account':
                    this.setActiveTab(2);
                    break;
                default:
                    this.setActiveTab(0);
                    break;
            }
        }
        this.tabsAccount.splice(index, 1);
        localStorage.setItem('MONITOR-TABS', JSON.stringify(this.tabsAccount));
    },

    pushTab(type, item) {
        this.tabsAccount.forEach(el => {
            el.active = false;
        });
        // Comprobamos si está abierto el tab con la información de la cuenta.
        // En el caso de localizar que el tab está abierto, buscamos su index y
        // ponemos el foco en el tab con `active`= true
        let tabAccountIsOpened;
        switch (type) {
            case 'account':
                tabAccountIsOpened = this.tabsAccount.find(x => x.account === item.account);
                break;

            case 'date':
                tabAccountIsOpened = this.tabsAccount.find(x => x.uid === item.uid);
                break;

            default:
                tabAccountIsOpened = this.tabsAccount.find(x => x.name === item.name);
                break;
        }

        if (tabAccountIsOpened) {
            const index = this.tabsAccount.indexOf(tabAccountIsOpened);
            // Fix porque hay 3 pestañas fijas y luego empiezan las dinámicas
            const indexDynamic = index + 3;
            this.tabsAccount[index].active = true;
            this.indexTabActive = indexDynamic;
        } else {
            this.tabsAccount.push({
                ...item,
                type,
                active: true
            });
        }
        localStorage.setItem('MONITOR-TABS', JSON.stringify(this.tabsAccount));
    },

    iconTab(type) {
        let iconClass = 'fa-calendar';
        switch (type) {
            case 'account':
                iconClass = 'fa-credit-card';
                break;
            case 'date':
                iconClass = 'fa-calendar-alt';
                break;
            default:
                iconClass = 'fa-archive';
                break;
        }
        return iconClass;
    },

    setActiveTab(index) {
        this.indexTabActive = index;
        this.tabsKey++;
    }
};

export default methods;
